/**
 * On the product page, make the main Loox star rating scroll down to the full
 * Loox reviews widget (#looxReviews) when clicked.
 *
 * Ratings inside a <product-card> (e.g. recommendations) are skipped — those
 * are links to their own product. #looxReviews is resolved at click time since
 * Loox can inject it after load.
 */
(function () {
  function bind() {
    document.querySelectorAll('.rating-wrapper').forEach((el) => {
      // Card ratings already link to their product — leave them alone.
      if (el.closest('product-card')) return;
      if (el.dataset.looxScrollBound) return;
      el.dataset.looxScrollBound = '1';

      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.style.cursor = 'pointer';

      const scrollToReviews = (event) => {
        const reviews = document.getElementById('looxReviews');
        if (!reviews) return;
        event.preventDefault();
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      el.addEventListener('click', scrollToReviews);
      el.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') scrollToReviews(event);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
